// Address Monitor Page Translation
export default {
  // Input placeholders
  placeholders: {
    monitorName: "Enter monitor name",
    monitorAddress: "Enter monitor address",
    selectCurrency: "Select currency",
  },

  // Buttons
  buttons: {
    reset: "Reset",
    search: "Search",
    addMonitor: "+ Add Monitor",
    view: "View",
    edit: "Edit",
  },

  // Statistics
  statistics: {
    totalMonitors: "address monitors",
    monitoring: "monitoring",
    total: "Total",
    count: "",
  },

  // Monitor types
  monitorTypes: {
    common: "Common Monitor",
    realtime: "Real-time Monitor",
  },

  // Monitor status
  status: {
    enable: "Monitoring",
    pause: "Paused",
  },

  // Monitor information
  monitorInfo: {
    monitorName: "Monitor Name",
    address: "Address",
    relatedCase: "Related Case",
    condition: "Condition",
    remark: "Remark",
    dynamics: "monitor dynamics",
    unread: "unread",
  },

  // Dialogs
  dialogs: {
    title: "Confirm",
    addMonitor: "Add Monitor",
    edit: "Edit",
    deleteConfirm: "This operation will permanently delete the file. Continue?",
    changeStatusConfirm: "Change status to",
    openMonitor: "Open Monitor",
    closeMonitor: "Close Monitor",
    dingTalkHelp: "DingTalk Robot Setup Instructions",
  },

  // Details drawer
  details: {
    title: "Details",
    transferIn: "Transfer In",
    transferOut: "Transfer Out",
    amount: "Amount",
    address: "Address",
    hash: "Hash",
    time: "Time",
  },

  // Messages
  messages: {
    noData: "No data available",
    deleteSuccess: "Monitor deleted successfully",
    deleteCancelled: "Deletion cancelled",
    editSuccess: "Modified successfully",
    closeSuccess: "Closed successfully",
    copySuccess: "Copied successfully!",
    loading: "Loading...",
  },

  // Confirm buttons
  confirm: {
    yes: "Yes",
    no: "No",
    ok: "OK",
    cancel: "Cancel",
  },
};
